import Swiper from "swiper";
import { Mousewheel, Navigation, Thumbs, FreeMode } from "swiper/modules";

import "swiper/css";
import "swiper/css/mousewheel";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/free-mode";

class ProductMediaSwiper extends HTMLElement {
  constructor() {
    super();

    this.productMediaSwiper = null;
    this.productThumbSwiper = null;
  }
  connectedCallback() {
    this.initSwipers();

    this.unsubscribeVariantChange = subscribe(
      PUB_SUB_EVENTS.variantChange,
      this.handleVariantChange.bind(this),
    );

    // On load, check for initial media ID
    document.addEventListener("DOMContentLoaded", () => {
      const initialMediaId = this.dataset.initialMediaId;
      if (initialMediaId) {
        this.updateMedia(initialMediaId);
      }
    });
  }

  initSwipers() {
    this.productThumbSliderEl = this.querySelector(
      ".main-product__media-thumbnails",
    );
    this.productThumbSwiper = new Swiper(this.productThumbSliderEl, {
      modules: [FreeMode],
      loop: false,
      freeMode: true,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      cssMode: true,
      centerInsufficientSlides: true,
      breakpoints: {
        320: {
          spaceBetween: 0,
        },
        768: {
          spaceBetween: 10,
        },
      },
    });

    this.productMediaSliderEl = this.querySelector(".main-product__slides");
    this.productMediaSwiper = new Swiper(this.productMediaSliderEl, {
      modules: [Navigation, Mousewheel, Thumbs],
      lazy: true,
      direction: "horizontal",
      slidesPerView: 1,
      effect: "slide",
      lazy: true,
      loop: true,
      speed: 800,
      navigation: {
        nextEl: this.querySelector(".swiper-button-next"),
        prevEl: this.querySelector(".swiper-button-prev"),
      },
      mousewheel: {
        forceToAxis: true,
      },
      watchSlidesProgress: true,
      thumbs: {
        swiper: this.productThumbSwiper,
      },
    });
  }

  disconnectedCallback() {
    // Unsubscribe to prevent memory leaks
    if (this.unsubscribeVariantChange) {
      this.unsubscribeVariantChange();
    }
  }

  handleVariantChange({ mediaId }) {
    this.updateMedia(mediaId);
  }

  updateMedia(mediaId) {
    if (!mediaId || !this.productMediaSwiper) return;

    const activeSlide = this.querySelector(`[data-media-id*="${mediaId}"]`);
    if (activeSlide) {
      const slideIndex = Array.from(
        this.querySelectorAll(".swiper-slide"),
      ).indexOf(activeSlide);

      if (slideIndex !== -1) {
        this.productMediaSwiper.slideTo(slideIndex);
      }
    }
  }
}

customElements.define("product-media-swiper", ProductMediaSwiper);
